import { h } from './index.js';

// biome-ignore lint/correctness/noUnusedImports: needed for Stencil
function wrapInTooltip(tooltipProp, content) {
    if (tooltipProp) {
        const tooltipProps = typeof tooltipProp === 'object' ? tooltipProp : { label: tooltipProp };
        return h("wui-tooltip", { ...tooltipProps }, content);
    }
    return content;
}

export { wrapInTooltip as w };
